import CertificateTemplateUpload from './CertificateTemplateUpload';

export default CertificateTemplateUpload;
